// IE 9-11 require all of the following polyfills.
import * as es6promise from 'es6-promise';
import 'core-js/features/array/from';
import 'core-js/es/array';
import 'core-js/es/map';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.symbol';
import 'core-js/features/url-search-params';

es6promise.polyfill();